<template>
  <div class="article">
    <div class="article-list">
      <CSSTitleLink :title-text="muzikReadTitle" :title-link="muzikReadURL" />
      <!-- <div class="grid">
        <div v-if="!loaded" class="skeleton-cover2 skeleton article" />
        <div v-if="!loaded" class="skeleton-cover2 skeleton article" />
        <a v-for="article in articleList1" :key="article.id" :style="{backgroundImage: `url(${article.cover})`}"
          :href="articleHref(article)" target="_blank" class="article cover" @click="articleOnClick(article)"
        >
          <div class="info">
            <div class="subject">
              {{ article.subject }}
            </div>
            <div class="publish">
              <span class="date">
                {{ article.displayPublishDate }}
              </span>
              <span class="dot">
                ⋅
              </span>
              <span class="author">
                {{ article.displayAuthorsText }}
              </span>
            </div>
          </div>
        </a>
      </div> -->
      <div class="list">
        <div v-for="article in articleList2" :key="article.id" class="article">
          <a v-cover-lazy-loader :data-src="article.cover" :data-default-src="'/img/cover-social/read.png'"
             :href="articleHref(article)" class="cover" target="_blank" rel="noopener noreferrer" :aria-label="article.cover"
             @click="articleOnClick(article)"
          >
            <!--  -->
          </a>
          <div class="info">
            <a :href="articleHref(article)" class="subject" target="_blank" rel="noopener noreferrer" :aria-label="article.subject" @click="articleOnClick(article)">
              {{ article.subject }}
            </a>
            <span class="content">
              {{ article.authors.map(author => author.name).join('、') }}/ {{ article.short_content || article.subject }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="pgnnp-container">
      <Paganiniplus />
    </div>
  </div>
</template>
<script>
import Paganiniplus from '@/components/tsp/Paganiniplus'
import ArticleService from '@/assets/services/ArticleService'
import CoverLazyLoader from '@/directives/CoverLazyLoader'
import CSSTitleLink from '@/components/css-web/CSSTitleLink'

export default {
  name: 'AIRArticleBlock',
  components: {
    CSSTitleLink,
    Paganiniplus
  },
  directives: {
    CoverLazyLoader
  },
  props: {},
  data() {
    return {
      loaded: false,
      articleList1: [],
      articleList2: []
    }
  },
  computed: {
    muzikReadURL() {
      return `https://${process.env.VUE_APP_MUZIK_READ}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/`
    },
    muzikReadTitle() {
      return this.$i18n.t('AIR.READ_HEADLINE')
    }
  },
  watch: {},
  created() {
    this.initArticleList()
  },
  mounted() {},
  updated() {},
  methods: {
    articleHref(article) {
      return article && article.id
        ? `https://${process.env.VUE_APP_MUZIK_READ}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/articles/${article.id}`
        : `https://${process.env.VUE_APP_MUZIK_READ}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/`
    },
    articleOnClick(article) {
      // console.log(`Article ${article.id} on click.`)
    },
    async initArticleList() {
      let params = {
        per_page: 4,
        page: 1,
        sort: '-published_at'
      }
      let articles = await ArticleService.getArticles(params)
      if (articles && articles.data) {
        articles.data.forEach(article => {
          article.displayPublishDate = article['published_at'].split(' ')[0]
          article.displayAuthorsText = article['authors'].map(item => item.name).join(', ')
          article.isImgLoaded = false
        })
        this.articleList1 = articles.data.slice(0, 2)
        this.articleList2 = articles.data.slice(2, 4)
        this.loaded = true
      }
    }
  }
}
</script>
<style lang="scss">
@import '@/assets/scss/variables.scss';
.article:after{
  content: "";
  display: block;
  clear: both;
}
.article-list {
  display: block;
  .grid {
    position: relative;
    margin: 0 -18px 36px;
    .article {
      position: relative;
      display: inline-block;
      float: left;
      width: calc(50% - 36px);
      height: 390px;
      margin: 0 18px;
      padding: 24px;
      border-radius: 12px;
      color: #ffffff;
      background-color: $grey-ec;
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      cursor: pointer;
      &.cover:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        width: 100%;
        height: 100%;
        border-radius: 12px;
        background-color: rgba(0, 0, 0, 0.23);
      }
      .info {
        position: absolute;
        left: 0px;
        bottom: 0px;
        width: 100%;
        padding: 24px;
        font-weight: 500;
        color: #ffffff;
      }
      .subject {
        position: relative;
        font-size: 24px;
        font-weight: 500;
        line-height: 1.63;
        @include ellipsis-with-lines(3);
      }
      .publish {
        position: relative;
        width: 100%;
        max-height: 32px;
        font-size: 14px;
        font-weight: 500;
        line-height: 1.64;

        white-space: nowrap; // Don't use with display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    &:after{
      content: "";
      display: block;
      clear: both;
    }
  }
  .list {
    .article {
      display: block;
      min-height: 147px;
      outline: none;
      overflow: hidden;
      .cover {
        float: left;
        width: 205px;
        height: 108px;
        margin-right: 28px;
        border-radius: 4px;
        border: solid 1px $grey-ec;
        background-color: $grey-ec;
        cursor: pointer;

        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
      }
      .info {
        float: left;
        width: calc((100% - 205px) - 28px);
        overflow: hidden;
        .subject {
          display: block;
          width: 100%;
          font-size: 20px;
          font-weight: 500;
          line-height: 1.6;
          text-decoration: none;
          color: $grey-50;
          cursor: pointer;

          white-space: nowrap; // Don't use with display: -webkit-box;
          word-wrap: break-word;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .content {
          display: block;
          height: 78px;
          font-size: 16px;
          font-weight: 500;
          line-height: 1.63;
          color: $grey-9b;
          @include ellipsis-with-lines(3);
        }
      }
    }
  }
}
.pgnnp-container {
  display: block;
  margin: 12px auto 36px;
}
@media only screen and (min-width: 1440px) {}
@media only screen and (max-width: 1439.98px) {
  .article-list {
    width: 100%;
    padding-right: 0;
  }
}
@media only screen and (max-width: 1023.98px) {
  .article-list {
    .grid {
      position: relative;
      margin: 0;
      .article {
        position: relative;
        display: inline-block;
        float: left;
        width: 100%;
        height: 390px;
        margin: 0 0 24px 0;
      }
    }
  }
}
@media only screen and (max-width: 767.98px) {
  .article-list {
    .grid {
      position: relative;
      margin: 0;
      .article {
        position: relative;
        display: inline-block;
        float: left;
        width: 100%;
        height: 300px;
        margin: 0 0 24px 0;
        .subject {
          position: relative;
          font-size: 20px;
          font-weight: 500;
          line-height: 1.6;
          @include ellipsis-with-lines(2);
        }
        .publish {
          position: relative;
          width: 100%;
          max-height: 32px;
          font-size: 12px;
          font-weight: 500;
          line-height: normal;
        }
      }
    }
    .list {
      .article {
        .cover {
          width: 110px;
          height: 110px;
          margin-right: 16px;
        }
        .info {
          width: calc((100% - 110px) - 16px);
          .subject {
            max-height: 64px;
            font-size: 20px;
            white-space: unset;
            @include ellipsis-with-lines(2);
          }
          .content {
            height: 36px;
            font-size: 12px;
            @include ellipsis-with-lines(2);
          }
        }
      }
    }
  }
  .pgnnp-container {
    margin: 0 auto 24px;
  }
}
@media only screen and (max-width: 368.98px) {
  .pgnnp-container {
    margin: 0 -24px 24px;
  }
}
</style>
